import axios from "axios";

axios.defaults.baseURL =
  process.env.REACT_APP_API_URL ||
  (String(window.location).includes("public-tools.prod.aws.cinch.io")
    ? "https://engine.cinch.io"
    : "https://engine-dev.cinch.io");

export function getPreviewInvite({ id, password }) {
  return axios.get(`/previewlink/invites/${id}/get-invite/${password}`);
}

export function submitSignup(featuredProduct, payload) {
  return axios.post(`/signup/${featuredProduct}`, payload);
}

export function getSignupStatus(featureFocus) {
  return axios.get(`/signup/status`, featureFocus ? { params: { feature_focus: featureFocus } } : undefined);
}
